// extracted by mini-css-extract-plugin
export default {"active":"SidebarLink_active__2RC3Y","tooltip":"SidebarLink_tooltip__mShNu"};